import React from 'react'
import styled from 'styled-components'
import { media } from 'app/assets/styles'
import { Picture } from 'app/common/picture'

type Props = {
    imageUrl: ?string
}

const DisplayableProductHeroImage = (props: Props) => {
    const { imageUrl } = props

    if (!imageUrl) {
        return null
    }

    return (
        <Container>
            <Picture singleImage imageUrl={[imageUrl]} />
        </Container>
    )
}

const Container = styled.div`
    width: 90%;
    ${media.small`
        width: 40%;
    `};
    display: flex;
    justify-content: center;
    margin-right: auto;
    margin-left: auto;
`

export { DisplayableProductHeroImage }
